import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    alpha,
    Button,
    IconButton,
    Card,
    CardContent,
    Chip,
    Tooltip,
    Modal
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import axios from 'axios';
import { axiosInstance, localAxiosGet } from '../Axios/axios';
import {
    Event,
    EventAvailable,
    EventBusy,
    AccessTime,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    Refresh,
    Alarm,
    AlarmOff,
    CheckCircle,
    Cancel,
    Timer,
    LocationOn,
    LocationOff, Close
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
// import TokenExpirePopup from './TokenExpirePopup';
import { useNavigate } from 'react-router-dom';

dayjs.extend(utc);
dayjs.extend(timezone);


const formatStatus = (status) => {
    if (!status) return '';
    switch (status.toLowerCase()) {
        case 'present': return 'Present';
        case 'absent': return 'Absent';
        case 'latearrival': return 'Late Arrival';
        case 'late': return 'Late';
        case 'leave': return 'Leave';
        case 'weekend': return 'Weekend';
        default: return status;
    }
};

const EmployeeAttendanceCalendar = ({ userId, onClose }) => {
    const theme = useTheme();
    const [selectedDate, setSelectedDate] = useState(dayjs().startOf('month'));
    const [selectedStatus, setSelectedStatus] = useState('');

    const accessToken = localStorage.getItem('accessToken');
    const locationId = localStorage.getItem('locationId');
    const organizationId = localStorage.getItem('organizationId');

    const [monthlyAttendance, setMonthlyAttendance] = useState({});
    const [monthlyOverview, setMonthlyOverview] = useState({
        present: 0,
        absent: 0,
        late: 0,
        leaves: 0,
        totalWorkingDays: 0,
        attendancePercentage: 0
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
    const navigate = useNavigate();
    const [selectedCalendarDate, setSelectedCalendarDate] = useState(dayjs().startOf('month'));
    const [holidays, setHolidays] = useState([]);

    const isDefaultCheckout = (checkoutTime) => {
        if (!checkoutTime) return true;
        return false;
    };

    const fetchHolidays = async () => {
        const year = selectedDate.year();
        const month = selectedDate.month() + 1;
        try {
            const response = await axiosInstance(localAxiosGet(
                `/organization/getAllHolidaysByYearAndMonth?year=${year}&organization_id=${organizationId}&location_id=${locationId}&month=${month}`,
                accessToken
            ));
            if (response.data && response.data.message && response.data.message.holidays) {
                setHolidays(response.data.message.holidays);
            }
        } catch (error) {
            console.error("Error fetching holidays:", error);
        }
    };

    useEffect(() => {
        let presentCount = 0;
        let lateCount = 0;
        let leavesCount = 0;

        const fetchAttendanceData = async () => {
            setLoading(true);
            try {
                const monthYearString = selectedDate.format('MMMM');              

                const [attendanceResponse] = await Promise.all([
                    axiosInstance(localAxiosGet(
                        `/organization/getAttendanceByEmployeeIdByStatus?employee_id=${userId}&month=${monthYearString}`,
                        accessToken
                    )),
                    fetchHolidays()
                ])
                const transformedData = {};
                const daysInMonth = selectedDate.daysInMonth();
                console.log('attendance records', attendanceResponse)
                let presentCount = 0;
                let absentCount = 0;
                let lateCount = 0;
                let leavesCount = 0;

                if (attendanceResponse.data && attendanceResponse.data.message && attendanceResponse.data.message.attendanceRecords) {
                    attendanceResponse.data.message.attendanceRecords.forEach(item => {
                        // Extract the day number from the date string (e.g., "2025-06-19" -> "19")
                        const day = dayjs(item.date).date();

                        const checkInTime = item.check_in ?
                            dayjs(item.check_in).format('HH:mm') : null;
                        const checkOutTime = item.check_out ?
                            dayjs(item.check_out).format('HH:mm') : null;
                        let status = item.status;

                        const checkInIp = item.office_premises?.check_in?.ip || null;
                        const checkOutIp = item.office_premises?.check_out?.ip || null;
                        const inOffice = item.office_premises?.check_in?.in_office === 'yes';
                        const outOffice = item.office_premises?.check_out?.in_office === 'yes';

                        transformedData[day] = {
                            date: item.date,
                            inTime: checkInTime,
                            outTime: checkOutTime || '--:--',
                            status: status,
                            break: item.break_time || null,
                            late: item.late_minutes ? `${item.late_minutes} Min` : null,
                            productionHours: item.production_hours ? `${item.production_hours} Hrs` : null,
                            isPositive: status === 'Present',
                            checkInIp: checkInIp,
                            checkOutIp: checkOutIp,
                            inOffice: inOffice,
                            outOffice: outOffice,
                            hasData: true
                        };

                        if (status === 'Present') {
                            presentCount++;
                        } else if (status === 'LateArrival') {
                            lateCount++;
                        } else if (status === 'Leave') {
                            leavesCount++;
                        } else if (status === 'Absent') {
                            absentCount++;
                        }
                    });

                    const totalWorkingDays = Object.values(transformedData)
                        .filter(day => day.status !== 'Weekend')
                        .length;
                    const attendancePercentage = totalWorkingDays > 0
                        ? ((presentCount + lateCount) / totalWorkingDays * 100).toFixed(1)
                        : 0;

                    setMonthlyAttendance(transformedData);
                    setMonthlyOverview({
                        present: presentCount,
                        absent: absentCount,
                        late: lateCount,
                        leaves: leavesCount,
                        totalWorkingDays,
                        attendancePercentage
                    });
                } else {
                    setMonthlyAttendance({});
                    setMonthlyOverview({
                        present: 0,
                        absent: 0,
                        late: 0,
                        leaves: 0,
                        totalWorkingDays: 0,
                        attendancePercentage: 0
                    });
                }
            } catch (error) {
                console.error("Error fetching attendance data:", error);
                setError("Failed to fetch attendance data. Please try again.");
               

                const daysInMonth = selectedDate.daysInMonth();
                const transformedData = {};
                for (let i = 1; i <= daysInMonth; i++) {
                    const currentDate = selectedDate.date(i);
                    const isWeekend = currentDate.day() === 0 || currentDate.day() === 6;
                    if (isWeekend) {
                        transformedData[i] = {
                            date: currentDate.format('YYYY-MM-DD'),
                            status: 'Weekend',
                            hasData: false
                        };
                    }
                }
                setMonthlyAttendance(transformedData);
                setMonthlyOverview({
                    present: 0,
                    absent: 0,
                    late: 0,
                    leaves: 0,
                    totalWorkingDays: 0,
                    attendancePercentage: 0
                });
            } finally {
                setLoading(false);
            }
        };
        fetchAttendanceData();
        setSelectedCalendarDate(selectedDate);
    }, [selectedDate, userId, accessToken]);

    const isHoliday = (day) => {
        return holidays.some(holiday =>
            dayjs(holiday.date).date() === day &&
            dayjs(holiday.date).month() === selectedCalendarDate.month()
        );
    };



    const handleDateChange = (newDate) => {
        setSelectedDate(newDate.startOf('month'));
    };

    const handleStatusChange = (event) => {
        setSelectedStatus(event.target.value);
    };

    const handlePrevMonth = () => {
        setSelectedDate(prevDate => prevDate.subtract(1, 'month'));
    };

    const handleNextMonth = () => {
        const nextMonth = selectedDate.add(1, 'month');
        setSelectedDate(nextMonth);
    };

   

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'present': return theme.palette.success.main;
            case 'absent': return theme.palette.error.main;
            case 'latearrival':
            case 'late': return theme.palette.warning.main;
            case 'leave': return theme.palette.info.main;
            case 'weekend': return theme.palette.grey[400];
            default: return theme.palette.grey[500];
        }
    };

    const getStatusIcon = (status) => {
        switch (status?.toLowerCase()) {
            case 'present': return <EventAvailable fontSize="small" />;
            case 'absent': return <EventBusy fontSize="small" />;
            case 'latearrival':
            case 'late': return <AccessTime fontSize="small" />;
            case 'leave': return <AlarmOff fontSize="small" />;
            case 'weekend': return <Event fontSize="small" />;
            default: return <Event fontSize="small" />;
        }
    };

    const getStatusLabel = (status) => {
        switch (status?.toLowerCase()) {
            case 'present': return 'Present';
            case 'absent': return 'Absent';
            case 'latearrival': return 'Late Arrival';
            case 'late': return 'Late';
            case 'leave': return 'Leave';
            case 'weekend': return 'Weekend';
            default: return status || '';
        }
    };

    const getMonthName = (date) => {
        return date.format('MMMM');
    };

    const statusOptions = [
        { value: '', label: 'All' },
        { value: 'Present', label: 'Present' },
        { value: 'Absent', label: 'Absent' },
        { value: 'LateArrival', label: 'Late' },
        { value: 'Leave', label: 'Leave' },
        { value: 'Weekend', label: 'Weekend' },
        { value: 'Holiday', label: 'Holiday' }
    ];
    return (
        <Box sx={{ pr: 1.5 }}>
            <Typography variant="h4" fontWeight="bold" marginBottom={3}>
                My Attendance
            </Typography>

            <Paper
                elevation={0}
                sx={{
                    p: 2,
                    mb: 3,
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 2,
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: 2,
                    background: `linear-gradient(to right, ${alpha(theme.palette.primary.light, 0.05)}, ${alpha(theme.palette.background.paper, 0.8)})`
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Event color="primary" sx={{ mr: 1.5 }} />
                    <Typography variant="subtitle1" fontWeight="medium">
                        Select Period
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 2, ml: 'auto', flexWrap: 'wrap', alignItems: 'center' }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            views={['year', 'month']}
                            label="Month and Year"
                            minDate={dayjs('2020-01-01')}
                            maxDate={dayjs().endOf('year')}
                            value={selectedDate}
                            onChange={handleDateChange}
                            renderInput={(params) => <TextField size="small" {...params} />}
                        />
                    </LocalizationProvider>
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                        <InputLabel>Status</InputLabel>
                        <Select
                            value={selectedStatus}
                            label="Status"
                            onChange={handleStatusChange}
                        >
                            {statusOptions.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </Paper>
            <Grid container spacing={3} sx={{ mb: 4 }}>
                <Grid item xs={12}>
                    <Card
                        elevation={0}
                        sx={{
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: 2,
                            height: '100%',
                            background: alpha(theme.palette.background.paper, 0.6)
                        }}
                    >
                        <CardContent sx={{ p: 3 }}>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Attendance Breakdown
                            </Typography>
                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                <Grid item xs={6} sm={3}>
                                    <Box sx={{
                                        p: 1.5,
                                        borderRadius: 2,
                                        bgcolor: alpha(theme.palette.success.main, 0.1),
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center'
                                    }}>
                                        <EventAvailable sx={{ color: theme.palette.success.main, mb: 1 }} />
                                        <Typography variant="h5" fontWeight="bold" color="success.main">
                                            {monthlyOverview.present}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Present
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={6} sm={3}>
                                    <Box sx={{
                                        p: 1.5,
                                        borderRadius: 2,
                                        bgcolor: alpha(theme.palette.error.main, 0.1),
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center'
                                    }}>
                                        <EventBusy sx={{ color: theme.palette.error.main, mb: 1 }} />
                                        <Typography variant="h5" fontWeight="bold" color="error.main">
                                            {monthlyOverview.absent}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Absent
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={6} sm={3}>
                                    <Box sx={{
                                        p: 1.5,
                                        borderRadius: 2,
                                        bgcolor: alpha(theme.palette.warning.main, 0.1),
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center'
                                    }}>
                                        <AccessTime sx={{ color: theme.palette.warning.main, mb: 1 }} />
                                        <Typography variant="h5" fontWeight="bold" color="warning.main">
                                            {monthlyOverview.late}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Late
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={6} sm={3}>
                                    <Box sx={{
                                        p: 1.5,
                                        borderRadius: 2,
                                        bgcolor: alpha(theme.palette.info.main, 0.1),
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center'
                                    }}>
                                        <AlarmOff sx={{ color: theme.palette.info.main, mb: 1 }} />
                                        <Typography variant="h5" fontWeight="bold" color="info.main">
                                            {monthlyOverview.leaves}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Leaves
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Box sx={{ mb: 4 }}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Event color="primary" sx={{ mr: 1.5 }} />
                        <Typography variant="subtitle1" fontWeight="medium">
                            Monthly Calendar View
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                            {getMonthName(selectedDate)} {selectedDate.year()}
                        </Typography>
                        <IconButton
                            size="small"
                            onClick={handlePrevMonth}
                            sx={{
                                bgcolor: alpha(theme.palette.primary.main, 0.1),
                                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.2) },
                                '&.Mui-disabled': { opacity: 0.5 }
                            }}
                        >
                            <KeyboardArrowLeft fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={handleNextMonth}
                            sx={{
                                bgcolor: alpha(theme.palette.primary.main, 0.1),
                                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.2) },
                                '&.Mui-disabled': { opacity: 0.5 }
                            }}
                        >
                            <KeyboardArrowRight fontSize="small" />
                        </IconButton>
                    </Box>
                </Box>
                <Paper
                    elevation={0}
                    sx={{
                        p: 2,
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: 2,
                        background: theme.palette.background.paper,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.05)'
                    }}
                >
                    <Grid container spacing={1} sx={{ mb: 2 }}>
                        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                            <Grid item xs={12 / 7} key={day}>
                                <Box
                                    sx={{
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        p: 1,
                                        color: day === 'Sun' || day === 'Sat' ? 'text.secondary' : 'text.primary',
                                        borderBottom: '1px solid rgba(0, 0, 0, 0.06)'
                                    }}
                                >
                                    {day}
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                    <Grid container spacing={1}>
                        {(() => {
                            const firstDayOfMonth = selectedCalendarDate.startOf('month');
                            const daysInMonth = selectedCalendarDate.daysInMonth();
                            const startingDayOfWeek = firstDayOfMonth.day();
                            const calendarCells = [];

                            for (let i = 0; i < startingDayOfWeek; i++) {
                                calendarCells.push(
                                    <Grid item xs={12 / 7} key={`empty-${i}`}>
                                        <Box
                                            sx={{
                                                // height: 100, 
                                                minHeight: { xs: 80, sm: 100 },
                                                opacity: 0.3,
                                                bgcolor: alpha('#f5f5f5', 0.3),
                                                borderRadius: 1
                                            }}
                                        />
                                    </Grid>
                                );
                            }

                            for (let day = 1; day <= daysInMonth; day++) {
                                const currentDate = selectedCalendarDate.date(day);
                                const dateString = currentDate.format('D');
                                const dayRecord = monthlyAttendance[dateString];
                                const isDayHoliday = isHoliday(day);

                                // Get holiday info if it's a holiday
                                const holidayInfo = isDayHoliday ?
                                    holidays.find(h => dayjs(h.date).date() === day && dayjs(h.date).month() === selectedCalendarDate.month())
                                    : null;

                                if (selectedStatus && dayRecord && dayRecord.status?.toLowerCase() !== selectedStatus.toLowerCase() &&
                                    !(selectedStatus.toLowerCase() === 'holiday' && isDayHoliday)) {
                                    calendarCells.push(
                                        <Grid item xs={12 / 7} key={`day-${day}`}>
                                            <Box
                                                sx={{
                                                    minHeight: { xs: 80, sm: 100 },
                                                    opacity: 0.3,
                                                    bgcolor: alpha('#f5f5f5', 0.3),
                                                    borderRadius: 1,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <Typography variant="body2">{day}</Typography>
                                            </Box>
                                        </Grid>
                                    );
                                    continue;
                                }

                                const status = dayRecord?.status;
                                const statusColor = status ? getStatusColor(status) : (isDayHoliday ? theme.palette.secondary.main : null);
                                const statusLabel = status ? formatStatus(status) : (isDayHoliday ? 'Holiday' : null);

                                calendarCells.push(
                                    <Grid item xs={12 / 7} key={`day-${day}`}>
                                        <Tooltip
                                            title={dayRecord ?
                                                `${statusLabel}: In: ${dayRecord.inTime || '--:--'}, Out: ${dayRecord.outTime || '--:--'}` :
                                                (isDayHoliday ? `Holiday: ${holidayInfo?.holiday_name || 'Holiday'}` : '')}
                                            arrow
                                        >
                                            <Box
                                                sx={{
                                                    minHeight: { xs: 80, sm: 100 },
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    borderRadius: 1,
                                                    border: (dayRecord || isDayHoliday) ? `1px solid ${alpha(statusColor, 0.3)}` : '1px solid rgba(0, 0, 0, 0.12)',
                                                    bgcolor: (dayRecord || isDayHoliday) ? alpha(statusColor, 0.1) : 'transparent',
                                                    position: 'relative',
                                                    cursor: (dayRecord || isDayHoliday) ? 'pointer' : 'default',
                                                    transition: 'all 0.2s',
                                                    '&:hover': {
                                                        transform: (dayRecord || isDayHoliday) ? 'translateY(-2px)' : 'none',
                                                        boxShadow: (dayRecord || isDayHoliday) ? '0 4px 8px rgba(0,0,0,0.1)' : 'none',
                                                        bgcolor: (dayRecord || isDayHoliday) ? alpha(statusColor, 0.2) : alpha('#f5f5f5', 0.1)
                                                    },
                                                }}
                                            >
                                                <Box sx={{
                                                    p: 1,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    borderBottom: (dayRecord || isDayHoliday) ? `1px dashed ${alpha(statusColor, 0.3)}` : 'none'
                                                }}>
                                                    <Typography
                                                        variant="body2"
                                                        fontWeight={day === dayjs().date() &&
                                                            selectedCalendarDate.month() === dayjs().month() &&
                                                            selectedCalendarDate.year() === dayjs().year() ? 'bold' : 'medium'}
                                                        sx={{
                                                            color: (dayRecord || isDayHoliday) ? statusColor : 'inherit',
                                                            bgcolor: day === dayjs().date() &&
                                                                selectedCalendarDate.month() === dayjs().month() &&
                                                                selectedCalendarDate.year() === dayjs().year() ?
                                                                alpha('#1a237e', 0.1) : 'transparent',
                                                            borderRadius: '50%',
                                                            width: 24,
                                                            height: 24,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                        {day}
                                                    </Typography>

                                                    {/* Show appropriate icon for holidays or attendance status */}
                                                    {isDayHoliday ? (
                                                        <Event fontSize="small" sx={{ color: statusColor }} />
                                                    ) : (
                                                        dayRecord && status && (
                                                            status.toLowerCase() === 'present' ? <CheckCircle fontSize="small" sx={{ color: statusColor }} /> :
                                                                status.toLowerCase() === 'absent' ? <Cancel fontSize="small" sx={{ color: statusColor }} /> :
                                                                    status.toLowerCase() === 'latearrival' ? <Timer fontSize="small" sx={{ color: statusColor }} /> :
                                                                        status.toLowerCase() === 'leave' ? <AlarmOff fontSize="small" sx={{ color: statusColor }} /> :
                                                                            <Event fontSize="small" sx={{ color: statusColor }} />
                                                        )
                                                    )}
                                                </Box>

                                                {/* Display chip for holidays or attendance status */}
                                                {(dayRecord || isDayHoliday) && (
                                                    <>
                                                        <Box sx={{ px: 1, pt: 1 }}>
                                                            <Chip
                                                                label={isDayHoliday ?
                                                                    (holidayInfo?.holiday_name || 'Holiday') :
                                                                    statusLabel}
                                                                size="small"
                                                                sx={{
                                                                    height: 20,
                                                                    fontSize: '0.65rem',
                                                                    backgroundColor: alpha(statusColor, 0.2),
                                                                    color: statusColor,
                                                                    fontWeight: 'medium',
                                                                    '& .MuiChip-label': { px: 1 }
                                                                }}
                                                            />
                                                        </Box>

                                                        {/* Only show time chips for attendance records, not holidays */}
                                                        {dayRecord && !isDayHoliday && (
                                                            <Box sx={{
                                                                px: 1,
                                                                mt: 'auto',
                                                                pb: 1,
                                                                display: 'flex',
                                                                flexDirection: {
                                                                    '@media (max-width:1350px)': 'column',
                                                                    lg: 'row'
                                                                },
                                                                flexWrap: {
                                                                    xs: 'wrap',
                                                                    '@media (max-width:1350px)': 'nowrap',
                                                                },
                                                                alignItems: {
                                                                    xs: 'flex-start',
                                                                    sm: 'flex-start',
                                                                },
                                                                gap: {
                                                                    xs: 0.5,
                                                                    '@media (min-width:1360px) and (max-width:1399px)': 0,
                                                                    '@media (min-width:1600px)': 4,
                                                                },
                                                                justifyContent: {
                                                                    xs: 'flex-start',
                                                                    xl: 'space-between'
                                                                },
                                                                width: {
                                                                    xl: '90%',
                                                                    lg: '100%'
                                                                }
                                                            }}>
                                                                {dayRecord.inTime && dayRecord.inTime !== '--:--' && (
                                                                    <Chip
                                                                        icon={
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                                {dayRecord.inOffice ?
                                                                                    <LocationOn sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#4caf50' }} /> :
                                                                                    <LocationOff sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#f44336' }} />
                                                                                }
                                                                                <Alarm sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#4caf50' }} />
                                                                            </Box>
                                                                        }
                                                                        label={dayRecord.inTime}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        sx={{
                                                                            height: { xs: 16, sm: 18 },
                                                                            p: { xs: '1px', sm: '2px' },
                                                                            fontSize: { xs: '0.55rem', sm: '0.65rem' },
                                                                            backgroundColor: alpha('#4caf50', 0.1),
                                                                            borderColor: alpha('#4caf50', 0.3),
                                                                            color: '#4caf50',
                                                                            '& .MuiChip-label': { px: { xs: 0.3, sm: 0.5 }, fontWeight: 'medium' },
                                                                            '& .MuiChip-icon': { mr: { xs: 0, sm: 0.1 }, ml: { xs: 0.2, sm: 0 } },
                                                                            '&:hover': {
                                                                                backgroundColor: alpha('#4caf50', 0.15),
                                                                                borderColor: alpha('#4caf50', 0.4)
                                                                            }
                                                                        }}
                                                                    />
                                                                )}

                                                                {dayRecord.outTime && (
                                                                    <Chip
                                                                        icon={
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                                {dayRecord.outOffice ?
                                                                                    <LocationOn sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#4caf50' }} /> :
                                                                                    <LocationOff sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#f44336' }} />
                                                                                }
                                                                                <AlarmOff sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#f44336' }} />
                                                                            </Box>
                                                                        }
                                                                        label={dayRecord.outTime}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        sx={{
                                                                            height: { xs: 16, sm: 18 },
                                                                            fontSize: { xs: '0.55rem', sm: '0.65rem' },
                                                                            backgroundColor: alpha('#f44336', 0.1),
                                                                            borderColor: alpha('#f44336', 0.3),
                                                                            color: '#f44336',
                                                                            '& .MuiChip-label': { px: { xs: 0.3, sm: 0.5 }, fontWeight: 'medium' },
                                                                            '& .MuiChip-icon': { mr: { xs: 0, sm: 0.1 }, ml: { xs: 0.2, sm: 0.1 } },
                                                                            '&:hover': {
                                                                                backgroundColor: alpha('#f44336', 0.15),
                                                                                borderColor: alpha('#f44336', 0.4)
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            </Box>
                                                        )}
                                                    </>
                                                )}
                                            </Box>
                                        </Tooltip>
                                    </Grid>
                                );
                            }

                            const totalCells = Math.ceil((daysInMonth + startingDayOfWeek) / 7) * 7;
                            const remainingCells = totalCells - (daysInMonth + startingDayOfWeek);
                            for (let i = 0; i < remainingCells; i++) {
                                calendarCells.push(
                                    <Grid item xs={12 / 7} key={`empty-end-${i}`}>
                                        <Box
                                            sx={{
                                                // height: 100, 
                                                minHeight: { xs: 80, sm: 100 },
                                                opacity: 0.3,
                                                bgcolor: alpha('#f5f5f5', 0.3),
                                                borderRadius: 1
                                            }}
                                        />
                                    </Grid>
                                );
                            }

                            return calendarCells;
                        })()}
                    </Grid>
                    <Box sx={{ mt: 3, display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: theme.palette.success.main, mr: 1 }} />
                            <Typography variant="caption">Present</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: theme.palette.error.main, mr: 1 }} />
                            <Typography variant="caption">Absent</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: theme.palette.warning.main, mr: 1 }} />
                            <Typography variant="caption">Late</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: theme.palette.info.main, mr: 1 }} />
                            <Typography variant="caption">Leave</Typography>
                        </Box>                        
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: theme.palette.secondary.main, mr: 1 }} />
                            <Typography variant="caption">Holiday</Typography>
                        </Box>
                    </Box>
                </Paper>
            </Box>
            <Box
                sx={{
                    mt: 4,
                    pt: 3,
                    borderTop: `1px solid ${theme.palette.divider}`,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 2
                }}
            >
                <Typography variant="body2" color="text.secondary">
                    Last updated: {dayjs().format('MMM D, YYYY h:mm A')}
                </Typography>
            </Box>

            
        </Box>
    );
};

export default EmployeeAttendanceCalendar;






















